import React, { useState } from 'react';
import { useInterval } from 'react-use';
import { RailsItemLabel } from '@sls-react/typings/services/rails/item';
import {
  differenceInHours,
  formatDistanceStrict,
  formatDistanceToNow,
} from 'date-fns';

interface Props {
  auctionEndedAt?: string;
  label: RailsItemLabel;
}

const ItemLabelPillAuctionText: React.FC<Props> = ({
  auctionEndedAt,
  label,
}) => {
  const [text, setText] = useState(label.text);

  useInterval(() => {
    if (auctionEndedAt) {
      const date = new Date(auctionEndedAt);
      const diff = differenceInHours(date, new Date());
      if (diff < 24 && diff >= 0) {
        setText(
          `Auction: ${formatDistanceToNow(date, { includeSeconds: true })}`,
        );
      }
    }
  }, 1000);

  return <>{text}</>;
};

export default ItemLabelPillAuctionText;
